import React, { Component } from "react";
import { Button, Col, Form, Layout, Row, Select, Radio } from "antd";

const { Option } = Select;
const { Content } = Layout;
class MemberCountryEntryForm extends Component {
  onFinish = (e) => {
    e.preventDefault();
    const { memberId, onSubmit } = this.props;
    this.props.form.validateFields((err, values) => {
      if (err) {
        return;
      }

      values["member_id"] = Number(memberId);

      this.onResetBtn();
      onSubmit(values);
    });
  };

  onResetBtn = () => {
    this.props.form.resetFields();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { memberId, countryList } = this.props;

    return (
      <div>
        <Content
          style={{
            background: "#fff",
            padding: 24,
            margin: "16px 0",
            minHeight: 150,
          }}
        >
          <h2>{memberId} | Member's Allow Country</h2>
          <Form
            name="filter-forms"
            colon={false}
            onSubmit={this.onFinish}
            hideRequiredMark
          >
            <Row gutter={24} justify="space-around">
              <Col xl={8}>
                <Form.Item name="region_code" label="Country">
                  {getFieldDecorator("region_code")(
                    <Select
                      showSearch
                      allowClear
                      placeholder="เลือกประเทศ"
                      style={{ width: "100%" }}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0 ||
                        option.props.value
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {countryList.map((c) => {
                        const { region_code, name } = c;
                        if (region_code === "NONE") {
                          return null;
                        }
                        return (
                          <Option key={region_code} value={region_code}>
                            {name}
                          </Option>
                        );
                      })}
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col xl={8}>
                <Form.Item name="is_restricted" label="Restriction">
                  {getFieldDecorator("is_restricted")(
                    <Radio.Group>
                      <Radio value={true}>Disallow</Radio>
                      <Radio value={false}>Allow</Radio>
                    </Radio.Group>
                  )}
                </Form.Item>
              </Col>
              <Col xl={8} style={{ textAlign: "end" }}>
                <Form.Item label="&nbsp;">
                  <Button
                    style={{ width: "120px", margin: "0 4px 0 4px" }}
                    onClick={() => this.onResetBtn()}
                  >
                    Reset
                  </Button>
                  <Button
                    style={{ width: "120px", margin: "0 4px 0 4px" }}
                    type="primary"
                    htmlType="submit"
                  >
                    Submit
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Content>
      </div>
    );
  }
}

export default Form.create({ name: "member_country_entry_form" })(
  MemberCountryEntryForm
);



// WEBPACK FOOTER //
// ./src/containers/MemberCountry/form.js